import { render, staticRenderFns } from "./EmployeeVacationsWidget.vue?vue&type=template&id=5f9a59a9&scoped=true&"
import script from "./EmployeeVacationsWidget.vue?vue&type=script&lang=js&"
export * from "./EmployeeVacationsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9a59a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f9a59a9')) {
      api.createRecord('5f9a59a9', component.options)
    } else {
      api.reload('5f9a59a9', component.options)
    }
    module.hot.accept("./EmployeeVacationsWidget.vue?vue&type=template&id=5f9a59a9&scoped=true&", function () {
      api.rerender('5f9a59a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/responsible/planing/widgets/EmployeeVacationsWidget.vue"
export default component.exports